import { useState } from 'react';

const useBox = () => {
  //show or hide overlay box
  const [overlayActive, setOverlayActive] = useState("false");
  const overlayToggle = (e) => {
    e.preventDefault();
    setOverlayActive(!overlayActive);
  };
  //show or hide avatar box
  const [avatarBoxActive, setAvatarBoxActive] = useState("false");
  const avatarBoxToggle = (e) => {
        e.preventDefault();
        setAvatarBoxActive(!avatarBoxActive);
  };
  //show or hide main ftp box
  const [photosBoxActive, setPhotosBoxActive] = useState("false");
  const photosBoxToggle = (e) => {
        e.preventDefault();
        setPhotosBoxActive(!photosBoxActive);
  };
  //open or close folders window
  const [foldersActive, setfoldersActive] = useState("false");
  const foldersToggle = (e) => {
          e.preventDefault();
          setfoldersActive(!foldersActive);
  };
  //show or hide upload box
  const [uploadBoxActive, setUploadBoxActive] = useState("false");
  const uploadBoxToggle = (e) => {
        e.preventDefault();
        setUploadBoxActive(!uploadBoxActive);
  };

  return {
    overlayToggle,
    avatarBoxToggle,
    uploadBoxToggle,
    photosBoxToggle,
    overlayActive,
    setOverlayActive,
    avatarBoxActive,
    uploadBoxActive,
    setAvatarBoxActive,
    setUploadBoxActive,
    photosBoxActive,
    setPhotosBoxActive,
    foldersActive,
    setfoldersActive,
    foldersToggle };
};

export default useBox;